var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7822_8083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05982 0 0 8.05982 0 18C0 27.9402 8.05982 36 18 36C27.9402 36 36 27.9402 36 18C36 8.05982 27.9402 0 18 0ZM18 32.9464C9.74732 32.9464 3.05357 26.2527 3.05357 18C3.05357 9.74732 9.74732 3.05357 18 3.05357C26.2527 3.05357 32.9464 9.74732 32.9464 18C32.9464 26.2527 26.2527 32.9464 18 32.9464Z",
    fill: "#FFB940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0708 25.0714C16.0708 25.5829 16.274 26.0735 16.6357 26.4351C16.9973 26.7968 17.4879 27 17.9994 27C18.5109 27 19.0014 26.7968 19.3631 26.4351C19.7248 26.0735 19.9279 25.5829 19.9279 25.0714C19.9279 24.5599 19.7248 24.0694 19.3631 23.7077C19.0014 23.346 18.5109 23.1429 17.9994 23.1429C17.4879 23.1429 16.9973 23.346 16.6357 23.7077C16.274 24.0694 16.0708 24.5599 16.0708 25.0714ZM17.0351 20.5714H18.9637C19.1404 20.5714 19.2851 20.4268 19.2851 20.25V9.32143C19.2851 9.14464 19.1404 9 18.9637 9H17.0351C16.8583 9 16.7137 9.14464 16.7137 9.32143V20.25C16.7137 20.4268 16.8583 20.5714 17.0351 20.5714Z",
    fill: "#FFB940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7822_8083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.67d5d1d52b85c91b605451675177b211.svg";
export { ForwardRef as ReactComponent };